import * as actionTypes from './actionTypes';
import { googleLoginApi, postTwofaValidateEmailApi,postTwofaLoginWithTacApi } from '../../apiUtils/api';

export const verifyGoogleLogin=(googleProfile,googleToken,email)=>{
    return dispatch => googleLoginApi(googleToken,email).then((res)=>res.json())
    .then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.VERIFY_GOOGLE_LOGIN_ERROR,error: data.error});
        }else {
            const { imageUrl, name } = googleProfile;
            let profile = {};
            profile.imageUrl=imageUrl;
            profile.name=name;

            dispatch({type: actionTypes.VERIFY_GOOGLE_LOGIN_SUCCESS, user: data.user, jwtToken: data.token, profile: profile });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.VERIFY_GOOGLE_LOGIN_ERROR, error: err});
    })
}

export const validateEmail=(email)=>{
    return dispatch => postTwofaValidateEmailApi(email).then((res)=>res.json())
    .then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.TWOFA_VALIDATE_EMAIL_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.TWOFA_VALIDATE_EMAIL_SUCCESS, email: email });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.TWOFA_VALIDATE_EMAIL_ERROR, error: err});
    })
}

export const loginWithTac=(email,loginTac)=>{
    return dispatch => postTwofaLoginWithTacApi(email,loginTac).then((res)=>res.json())
    .then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.TWOFA_LOGIN_TAC_ERROR,error: data.error});
        }else {
            let profile = {};
            profile.name=email;
            dispatch({type: actionTypes.TWOFA_LOGIN_TAC_SUCCESS, 
                user: data.user, jwtToken: data.token, profile });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.TWOFA_LOGIN_TAC_ERROR, error: err});
    })
}

export const logout=()=>{
    return { type: actionTypes.LOGOUT };
}


// WEBPACK FOOTER //
// ./src/redux/auth/actions.js